import type { TabProps } from "@mui/material";
import { Tab } from "@mui/material";
import type { NavLink, To } from "react-router";

/**
 * TL;DR: I can't seem to get MUI and react-router 6 to play nicely in TS
 */
export const NavTab = Tab as any as React.ComponentType<
  TabProps & { to?: To; component?: typeof NavLink }
>;

/**
 * MUI Tab supposedly supports a component prop and allows for sibling props
 * as defined on the component value. This pair of { component: NavLink, to: string }
 * should work, but it doesn't.
 *
 * Previously, I would have done something like:
 * <Tab
 *   {...{
 *      component: NavLink,
 *      to: "/"
 *   }}
 *   />
 * This approach generally skips type checking of the spread props. However,
 * SWC appears to compile these kinds of components incorrectly (wouldn't affect
 * production, but causes error logging in dev). It ends up inserting the old
 * React.createElement() instead of jsxDev(), and causes parameter issues wrt
 * inline source mapping.
 *
 * Anyway, after a lot of struggle trying to make it work, this is a simple
 * typing fix that compiles away to nothing.
 */
